/*jshint esversion: 9 */

import FingerprintJS from '@fingerprintjs/fingerprintjs';

// ponytail: pré-existente, não relacionado a wire:navigate -- <meta
// name="csrf-token"> nunca existiu em web/layout.blade.php nem
// web/admin-layout.blade.php (só no layout da Central de Ajuda), então
// document.querySelector(...).getAttribute(...) sempre quebrava com
// "Cannot read properties of null" em toda página do site/painel.
const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';

// Função para injetar o cookie de forma limpa
const setFpCookie = (value) => {
    "use strict";
    const d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 ano
    document.cookie = `trirs_fp=${value};expires=${d.toUTCString()};path=/;SameSite=None;Secure`;
};

const syncWithSession = (value) => {
    "use strict";
    const lastSync = localStorage.getItem('trirs_fp_last_sync');
    const now = Date.now();

    // Evita múltiplas sincronizações em um curto período (ex: 1 hora)
    if (lastSync && (now - parseInt(lastSync, 10) < 60 * 60 * 1000 * 24)) {
        return;
    }

    fetch('/tracker/sync-fingerprint', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken()
        },
        body: JSON.stringify({fingerprint: value})
    });
    // save last sync in localStorage to avoid multiple syncs in short time
    localStorage.setItem('trirs_fp_last_sync', Date.now().toString());
};

// Inicialização Assíncrona
const initFingerprint = async () => {
    "use strict";
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    const visitorId = result.visitorId;

    setFpCookie(visitorId);
    syncWithSession(visitorId);

    window.trirs_visitor_id = visitorId;

    // Dispara um evento nativo que o Livewire pode ouvir via x-on ou @window
    window.dispatchEvent(new CustomEvent('trirs-fp-ready', {
        detail: visitorId
    }));
};

initFingerprint();

const UserTracker = {
    validActions: {
        page_view: 'page_view',
        select_payment_method: 'select_payment_method',
    },
    getVisitorId: () => {
        "use strict";
        return window.trirs_visitor_id || null;
    },
    trackAction: (action, data = {}) => {
        if (!UserTracker.validActions.hasOwnProperty(action)) {
            console.error(`Ação inválida para UserTracker: ${action}`);
            return;
        }
        const payload = {action: action, data: data, fingerprint: UserTracker.getVisitorId()};
        fetch('/tracker/track-action', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken()
            },
            body: JSON.stringify(payload)
        });
    },
    addInfo: (info, field) => {
        const payload = {info: info, field: field, fingerprint: UserTracker.getVisitorId()};
        fetch('/tracker/add-info', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken()
            },
            body: JSON.stringify(payload)
        });
    }
};

window.UserTracker = UserTracker;
